<template>
    <div class="idUpload">
        <div v-if="alreadyAdded || added">Thanks for adding your ID.</div>

        <div v-else>
            <h2>ID required for {{ reservation.event_title }}</h2>
            <p>
                This event requires you to upload photo ID such as a drivers
                license or passport and add the name of the ticketholder.
                <br />Please note the name you enter below must match that on
                the ID. You may not be allowed entry if they do not match.
            </p>

            <div
                v-for="(identification, index) in form.identifications"
                :key="index"
                class="identification"
            >
                <h4>Ticket Holder {{ index + 1 }} Details</h4>

                <input
                    v-model="identification.identification_full_name"
                    class="form__input form__input--secondary"
                    type="text"
                    :placeholder="__('Full Name')"
                />

                <p
                    class="error"
                    v-if="
                        form.errors.has(
                            'identifications.' +
                                index +
                                '.identification_full_name'
                        )
                    "
                    v-html="
                        form.errors.get(
                            'identifications.' +
                                index +
                                '.identification_full_name'
                        )
                    "
                ></p>

                <p
                    class="error"
                    v-for="(e, i) in errors[
                        'fields.identifications.' +
                            index +
                            '.identification_full_name'
                    ]"
                    :key="'identification_full_name' + i"
                    v-html="'Please ensure you have attached some ID'"
                ></p>
                <label for=""
                    >Please attach photo ID for this ticketholder. Maximum image
                    size 5mb. File extension must be jpg, jpeg, png, bmp, gif,
                    svg, or webp</label
                >
                <input type="file" @change="addId($event, index)" />
                <p
                    class="error"
                    v-if="
                        form.errors.has(
                            'identifications.' + index + '.identification'
                        )
                    "
                    v-html="
                        form.errors.get(
                            'identifications.' + index + '.identification'
                        )
                    "
                ></p>

                <p
                    class="error"
                    v-for="(e, i) in errors[
                        'fields.identifications.' + index + '.identification'
                    ]"
                    :key="'identification' + i"
                    v-html="'Please enter the full name of this ticket holder'"
                ></p>
            </div>

            <button
                :disable="form.busy"
                @click.prevent="uploadID"
                type="button"
                class="btn btn--quaternary"
            >
                {{ form.busy ? "Please wait..." : "Upload ID" }}
            </button>
        </div>
    </div>
</template>

<script>
import { Form } from "vform";
import { serialize } from "object-to-formdata";
export default {
    props: {
        errors: {
            required: false,
            type: Object,
        },
        reservation: {
            required: true,
            type: Object,
        },
        resIndex: {
            required: true,
        },
    },
    computed: {
        alreadyAdded() {
            if (this.reservation.tickets) {
                var $added = false;
                this.reservation.tickets.identifications.forEach((item) => {
                    if (item.identification_full_name && item.identification) {
                        $added = true;
                    }
                });

                return $added;
            }

            if (this.reservation.seats) {
                var $added = false;
                this.reservation.seats.identifications.forEach((item) => {
                    if (item.identification_full_name && item.identification) {
                        $added = true;
                    }
                });

                return $added;
            }

            return false;
        },
    },
    created() {
        if (this.reservation.tickets) {
            this.reservation.tickets.identifications.forEach((item) => {
                this.form.identifications.push({
                    identification_full_name: item.identification_full_name,
                    identification: item.identification,
                });
            });
        }

        if (this.reservation.seats) {
            this.reservation.seats.identifications.forEach((item) => {
                this.form.identifications.push({
                    identification_full_name: item.identification_full_name,
                    identification: item.identification,
                });
            });
        }
    },
    data() {
        return {
            added: false,
            form: Form.make({
                index: this.resIndex,
                identifications: [],
            }),
        };
    },
    methods: {
        addId(event, index) {
            const file = event.target.files[0];
            this.form.identifications[index].identification = file;
        },
        uploadID() {
            this.form
                .submit("POST", "/checkout/upload-id", {
                    transformRequest: [
                        function (data, headers) {
                            return serialize(data, { indices: true });
                        },
                    ],
                })
                .then((response) => {
                    this.added = true;
                });
        },
    },
};
</script>

<style>
.idUpload {
    background: #e9e9e9;
    padding: 15px;
    margin-bottom: 10px;
}
.idUpload input[type="text"] {
    margin-bottom: 5px;
    margin-bottom: 10px;
}
.idUpload input[type="file"] {
    margin-bottom: 10px;
}
.idUpload p {
    margin-bottom: 20px;
}
.idUpload label {
    display: block;
    margin-bottom: 5px;
}
.identification {
    background: white;
    padding: 15px;
    margin-bottom: 20px;
}
.idUpload .error {
    font-weight: bold;
    margin-bottom: 20px;
    color: red;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Partials/Identification-upload.vue